  // Categorize repositories by visibility and ownership (for graph grouping)
  const categorizeRepositoriesByVisibility = (repos) => {
    const groups = { public: [], private: [] };
    repos.forEach((repo) => {
      if (repo.private) groups.private.push(repo); else groups.public.push(repo);
    });
    return groups;
  };

  const categorizeRepositoriesByOwner = (repos) => {
    const owners = {};
    repos.forEach((repo) => {
      const owner = repo.owner || 'unknown';
      if (!owners[owner]) owners[owner] = [];
      owners[owner].push(repo);
    });
    return owners;
  };

  // Group scopes by in_scope flag
  const groupScopesByInScope = (scopes) => {
    const result = { true: [], false: [] };
    scopes.forEach((s) => {
      if (s.in_scope) result.true.push(s); else result.false.push(s);
    });
    return result;
  };

    // Group scopes by action (prefix before ':'). Items without ':' go under 'misc'
    const groupScopesByAction = (scopes) => {
        const actionMap = {};
        scopes.forEach((s) => {
          const raw = typeof s === 'string' ? s : (s.scope || '');
          const [action, resource] = raw.includes(':') ? raw.split(':', 2) : ['misc', raw];
          const normalizedAction = action || 'misc';
          const resourceName = resource || raw;
          if (!actionMap[normalizedAction]) actionMap[normalizedAction] = new Set();
          if (resourceName) actionMap[normalizedAction].add(resourceName);
        });
        // Convert Sets to arrays
        return Object.fromEntries(Object.entries(actionMap).map(([k, v]) => [k, Array.from(v)]));
      };
    
  export { categorizeRepositoriesByVisibility, categorizeRepositoriesByOwner, groupScopesByInScope, groupScopesByAction };

